// extracted by mini-css-extract-plugin
module.exports = {"wallets":"choose-wallet_wallets__1iBk9","btn":"choose-wallet_btn__12X3t","btn-grad":"choose-wallet_btn-grad__22l-F","btn-sm":"choose-wallet_btn-sm__3PDId"};